import { createInertiaApp } from "@inertiajs/react"
import resolvePage from "~/lib/resolve-page"

void createInertiaApp({
  resolve: resolvePage,

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // このエントリポイントは Inertia のページでしか読み込まれない前提。
  // 移行中は HAML のページも残っているので、root 要素が無ければ黙って諦める
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
        "Inertia のページ以外で inertia.tsx が読み込まれています。" +
        'vite_typescript_tag "inertia" が Inertia 用レイアウトにだけ入っているか確認してください。',
    )
  }
})
